"use client";

import { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import classNames from "classnames";

const FaqArticle = ({ article, startOpen = false }) => {
  const [isOpen, setIsOpen] = useState(startOpen);

  return (
    <div className="faq-article">
      <div
        onClick={() => setIsOpen(!isOpen)}
        aria-controls={article.id}
        aria-expanded={isOpen}
        className="d-flex justify-content-between align-items-center cursor-pointer py-3"
      >
        <p
          className="mb-0 font-weight-bold faq-jump-link"
          id={article.slug}
        >
          {article.title}
        </p>
        <span className={classNames("toggle", isOpen && "expanded")} />
      </div>
      <Collapse in={isOpen}>
        <div id={article.id}>
          <p className="mb-3 faq-support-content">{article.content}</p>
        </div>
      </Collapse>
    </div>
  );
};

export default FaqArticle;
